<template>
  <!-- 在这不能使用背景颜色，需要从外部影响，涉及到背景图片的时候 -->
  <div class="top-title">
    <div style="clear">
      <div class="logo pull-left">
        <router-link :to="{ name: 'Index' }">
          <complete-logo />
        </router-link>
      </div>
      <div class="jump-lable pull-right">
        <router-link v-if="jumpUserType === 'user'" :to="{ name: 'UserLogin' }">
          家长登录
        </router-link>
        <router-link v-if="jumpUserType === 'teacher'" :to="{ name: 'TeacherLogin' }">
          教员登录
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { CompleteLogo } from '@/components'

export default {
  name: 'LoginHeader',
  components: {
    CompleteLogo
  },
  props: {
    jumpUserType: { default: 'user' }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  }
}
</script>
<style lang="stylus">
  .top-title {
    width: 100%;
    height: 44px;
    padding: 5px 15px;
    background-color: #fff;

    .jump-lable {
      a {
        font-family: PingFang-SC-Medium;
        font-size: 18px;
        line-height: 28px;
        color: #333333;
      }
    }
  }
</style>
